/**
 * Build SEO-friendly URLs for refurbished listings.
 * URL shape: /refurbished/{kebab-slug}-{first-8-of-uuid}
 * The trailing 8-char id segment guarantees uniqueness and lets the backend resolve the listing.
 */
export function slugify(text) {
  if (!text) return '';
  return String(text)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '') // strip accents
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function listingSlug(device) {
  if (!device) return '';
  const name = device.device_name || `${device.brand || ''} ${device.model || ''}`.trim();
  const parts = [name];
  if (device.storage) parts.push(device.storage);
  if (device.color) parts.push(device.color);
  if (device.condition_grade) parts.push(`grade-${device.condition_grade}`);
  const slug = slugify(parts.filter(Boolean).join(' '));
  const shortId = (device.id || '').replace(/-/g, '').slice(0, 8);
  return slug ? `${slug}-${shortId}` : (device.id || '');
}

export function listingUrl(device) {
  return `/refurbished/${listingSlug(device)}`;
}

/** Extract the listing UUID prefix from a slug-id (e.g., 'iphone-15-pro-a3d23536' → 'a3d23536'). */
export function extractListingId(slugOrId) {
  if (!slugOrId) return '';
  // Already a UUID
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(slugOrId)) return slugOrId;
  // Slug with trailing 8-hex id
  const match = String(slugOrId).match(/-([0-9a-f]{8})$/i);
  return match ? match[1] : slugOrId;
}
